import React from 'react';
import { View, Text, Switch, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { NOTIFICATION_COLORS } from '@/constants/residents/mobile/notificationColors';

type Props = {
  label: string;
  subtitle?: string;
  value: boolean;
  onChange: (v: boolean) => void;
};

export const NotificationToggleRow: React.FC<Props> = ({ label, subtitle, value, onChange }) => {
  return (
    <View style={styles.toggleRow}>
      <View style={styles.toggleCopy}>
        <Text style={styles.toggleLabel}>{label}</Text>
        {!!subtitle && <Text style={styles.toggleSub}>{subtitle}</Text>}
      </View>
      <Switch
        value={value}
        onValueChange={onChange}
        trackColor={{ false: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, true: NOTIFICATION_COLORS.switchTrackOnDesktop }}
        thumbColor={NOTIFICATION_COLORS.switchThumb}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  toggleRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 12, borderBottomWidth: 1, borderBottomColor: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY },
  toggleCopy: { flex: 1, paddingRight: 12 },
  toggleLabel: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, fontSize: 16, fontWeight: '700' },
  toggleSub: { color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY, fontSize: 14 },
});

export default NotificationToggleRow;


